import React, { memo } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { RowLayout } from "../../util/accordianStyles";
import useDoorShoeColorSelector from "./useDoorShoeColorSelector";
import { styled } from "@mui/material/styles";
import { Badge } from "@mui/material";
import { doorShoeColors} from "./defaults";

function DoorShoeColorAccordian() {
  const { checkMark, variant, handleClick } = useDoorShoeColorSelector();

  const StyledBadge = styled(Badge)({
    "& .MuiBadge-badge": {
      backgroundColor: "#f0be07",
    },
  });

  return (
    <ReusableAccordian
      accordionName="doorShoeColor"
      heading="Door Shoe Color"
      secondaryHeading="Select color"
    >
      <RowLayout>
         {doorShoeColors.map((state) => (
              <StyledBadge badgeContent={state.isNew ? "New!" : undefined} style={{gap: "18px"}}>
                <div key={state.id} onClick={() => handleClick(state.label)}>
                  <Choices
                    label={state.label}
                    variant={variant(state.label)}
                    checkMark={checkMark(state.label)}
                    wide={true}
                  />
                </div>
              </StyledBadge>
            ))}
      </RowLayout>
    </ReusableAccordian>
  );
}

export default memo(DoorShoeColorAccordian);
